import Container from './container'

export default Container


// WEBPACK FOOTER //
// ./src/ui/record-display-list/index.js